import { useEffect, useRef } from 'react';
import { useMatches } from 'react-router-dom';

import type { Handle } from '@remix-run/router';
import type { RouteObject } from 'react-router-dom';
import type { Nullish } from '~/types/generics';

const getClosestMatchHandleProp = <T extends keyof Handle>(propName: T, matches: RouteObject[]) => {
  for (let i = matches.length - 1; i >= 0; i--) {
    const handle = matches[i].handle;
    if (handle?.[propName] !== undefined) {
      return handle[propName];
    }
  }
  return undefined;
};

const useMatchHandlePropChange = <T extends keyof Handle>(propName: T, cb: (prop: Nullish<Handle[T]>) => void) => {
  const matches = useMatches() as RouteObject[];
  const prevValue = useRef<Nullish<Handle[T]>>();

  useEffect(() => {
    const closestValue = getClosestMatchHandleProp(propName, matches);
    if (closestValue !== prevValue.current) {
      prevValue.current = closestValue;
      cb(closestValue);
    }
  }, [matches, cb, propName]);
};

export default useMatchHandlePropChange;
